class ScrollingText extends HTMLElement {
	connectedCallback() {
		this.initialize();
	}

	initialize() {
		const textContent = this.getAttribute('text') || this.querySelector('.tt-scrolling-text-content')?.textContent?.trim() || '';
		const scrollSpeed = this.getAttribute('scroll-speed') || '15';
		const direction = this.getAttribute('direction') || 'normal';
		const variant = this.getAttribute('variant') || 'normal';
		const uppercase = this.getAttribute('uppercase') !== 'false';

		this.classList.add('tt-scrolling-text');

		if (direction === 'reverse') {
			this.classList.add('scr-text-reverse');
		}

		if (variant === 'stroke') {
			this.classList.add('scr-text-stroke');
		}

		let inner = this.querySelector('.tt-scrolling-text-inner');

		if (!inner) {
			inner = document.createElement('div');
			inner.className = 'tt-scrolling-text-inner tt-scrolling-text-seamless';
			if (uppercase) {
				inner.classList.add('text-uppercase');
			}
			inner.setAttribute('data-text', textContent);

			const span1 = document.createElement('span');
			span1.className = 'tt-scrolling-text-content';
			span1.textContent = textContent;

			const span2 = document.createElement('span');
			span2.className = 'tt-scrolling-text-content';
			span2.setAttribute('aria-hidden', 'true');
			span2.textContent = textContent;

			inner.appendChild(span1);
			inner.appendChild(span2);
			this.appendChild(inner);
		} else if (uppercase) {
			inner.classList.add('text-uppercase');
		}

		inner.style.animationDuration = `${scrollSpeed}s`;
	}
}

customElements.define('scrolling-text', ScrollingText);
